import { takeLatest, call, put, select } from 'redux-saga/effects';
import axios from 'axios';
import { checkDownloadFailure, checkDownloadSuccess, checkDownloadRequest } from '../reducers/checkInternet';
const NetworkSpeed = require('network-speed');

function* checkDownloadAxios() {

  const testNetworkSpeed = new NetworkSpeed();
  var speed = 0;
  const baseUrl = 'https://eu.httpbin.org/stream-bytes/50000000';
  const fileSizeInBytes = 50000000;
 
  const response = yield call(() => {
    
    return testNetworkSpeed.checkDownloadSpeed(baseUrl, fileSizeInBytes);
  });

  return response;
}

function* workerCheckDownloadSaga() {
  
  try {
    const response = yield call(checkDownloadAxios);
    
    const responseFromCheckCode = response.mbps;

    yield put(checkDownloadSuccess(responseFromCheckCode));
    if (response.status === 500) {
      yield put(checkDownloadFailure(responseFromCheckCode));
    }
  } catch (error) {
    yield put(checkDownloadFailure(error));
  }
}

export function* watcherCheckDownloadSaga() {
  yield takeLatest(checkDownloadRequest().type, workerCheckDownloadSaga);
}
